import { axiosGet } from "../../../Helpers/AxiosHelper";

export const GetVinData = async ({ url, setLoading, screen }) => {
  setLoading && setLoading(true);
  let response = await axiosGet({ url, withSNo: false });
  setLoading && setLoading(false);

  let data = response.data?.data;
  if (!Array.isArray(data) && data != null) data = [data];

  data.map((item) => {
    item.stockNumber = item.VIN.slice(-6);
  });
  let forSelect = data?.map((item) => {
    const vehicleTitle = item.vehicleTitle ? item.vehicleTitle : item.make + " " + item.model + " " + item.year;
    return {
      label: `${item.stockNumber} - ${vehicleTitle}`,
      stockNumber: item.stockNumber,
      VIN: item.VIN,
      title: vehicleTitle,
      value: item.id,
      coverImage: item.vehicleImages.length > 0 ? item.vehicleImages?.[item.coverImage || 0]?.path : "",
      description: item.VIN,
      status: screen ? item.status : undefined,
    };
  });

  return { data, forSelect };
};
